import { Switch, Route, Redirect } from "react-router-dom";
import LogoDiad from "../../assets/logodiadunjbg.png";
import { useAuth } from "../../utils/useAuth";
import * as SHARED from "../../utils/shared";
import { Link } from "react-router-dom";

function LayoutInicio({ routes }) {
  const { isAdmin, isRegistrador } = useAuth();

  if (isAdmin) return <Redirect to="/app" />;

  if (isRegistrador) return <Redirect to="/sistema" />;

  return (
    <div className="flex flex-col min-h-screen">
      <header className="w-full px-6 pt-8">
        <Link to="/" className="flex justify-center">
          <img src={LogoDiad} alt="Logo DIAD-UNJBG" className="w-auto" />
        </Link>
      </header>
      <main className="flex-1 w-full max-w-7xl mx-auto px-6">
        <LoadRoutes routes={routes} />
      </main>
      <footer className="w-full px-6 pb-8">
        <p className="text-center font-semibold text-xs text-gray-400">
          {SHARED.TITLE_SISTEMA_SHORT}
        </p>
      </footer>
    </div>
  );
}
export default LayoutInicio;

/**
 * Carga las rutas definidas en el archivo de rutas.
 * @param {Array} routes
 */
function LoadRoutes(props) {
  const { routes, user } = props;
  return (
    <Switch>
      {routes.map((route, index) => (
        <Route
          key={index}
          path={route.path}
          exact={route.exact}
          component={(props) => <route.component {...props} user={user} />}
        />
      ))}
    </Switch>
  );
}
